import { Pipe, PipeTransform } from '@angular/core';
import { TIMESTAMP } from '../constants/general-constants';

enum Months {
  Jan,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec
}

@Pipe({ name: 'timestamp-date' })
export class TimestampDatePipe implements PipeTransform {
  public transform(value: any, args?: any): any {
    if (args === TIMESTAMP) {
      if (value) {
        const epochDate = new Date(value * 1000);
        const min = String(epochDate.getMinutes()).padStart(2, '0');
        const hour = ((epochDate.getHours() + 11) % 12) + 1;
        const meridiem = epochDate.getHours() > 12 ? 'PM' : 'AM';

        return `${epochDate.getFullYear()}/${
          Months[epochDate.getMonth()]
        }/${epochDate.getDate()}   ${hour}:${min} ${meridiem}`;
      }
    }

    return value;
  }
}
